module.exports = __webpack_public_path__ + "static/media/accessory12.c898cff2.webp";